module.exports = __webpack_public_path__ + "img/bg7.b539ce9b.jpg";